<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<input id="brePopFirstElement" tabindex="{{tabLevel + 1}}" type="checkbox" class="exception-checkboxes" (change)="changeSelectLoco();" [(ngModel)]="selectedLoco" name="selectedLoco" value="{{selectedLoco}}">
<div class="exception-loco-id" (click)="locoSelection();">
    <span class="loco-tag">{{displayLocoId}}</span>
</div>

<div class="exception-intended-usage">
    <div *ngIf='lmsException.intendedUsageDesc'>{{lmsException.intendedUsageDesc}}</div>
    <div *ngIf='lmsException.intendedUsageReason' class="intended-reason">{{lmsException.intendedUsageReason}}</div>
    <div *ngIf='lmsException.intendedUsageNote'>Note:<span class="intended-notes">{{lmsException.intendedUsageNote}}</span></div>
</div>
<div class="exception-info">
    <div class="clearfix bre-blocks" *ngIf="lmsException?.tripPlamCompExcptnInd === 'E'">
        <p class="color-red">Trip Plan exception, select reason. (Trip Plan: {{lmsException.tripPlanTrnId}})</p>
        <p class="info-text" *ngIf="selectedLoco">
            <span class="pull-left add-reason">Add Reason: </span>
            <a tabindex="{{tabLevel + 2}}" href="javascript:;;" class="select-reason" (click)="addResonOverlay.toggle($event);">{{selectedTripPlanExceptionDesc}} <span class="angle-down"></span> </a>
            <span class="other-reason-text">{{displayOtherDesc}}</span>
        </p>
        <div class="clearfix color-red" *ngIf="lmsException.isLmsExceptionInAddReason">Please select reason</div>
        <p-overlayPanel #addResonOverlay [dismissable]="true" appendTo="body">
            <div class="exception-overlay">
                <ul>
                    <li *ngFor="let tripPlanException of tripPlanExceptionArr; let i = index;">
                        <p-radioButton labelStyleClass="radio-btn-lable" name="tripPlanExcep-{{lmsException.locoId}}" value="{{tripPlanException.reasonCode}}" label="{{tripPlanException.reasonDescription}}" [(ngModel)]="selectedTripPlanExceptionCode" tabindex="{{tabLevel + 3 + i }}"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton labelStyleClass="radio-btn-lable" tabindex="{{tabLevel + 50}}" name="tripPlanExcep-{{lmsException.locoId}}" value="Other" label="OTHER REASON" [(ngModel)]="selectedTripPlanExceptionCode"></p-radioButton>
                    </li>
                </ul>
                <textarea disabled="{{(selectedTripPlanExceptionCode!= 'Other') ? 'true' : 'false'}}" [(ngModel)]="tripPlanOtherReason" name='tripPlanOtherReason' class="{{(selectedTripPlanExceptionCode!= 'Other') ? 'other-reason-disabled' : 'other-reason'}}" tabindex="{{tabLevel + 52}}"></textarea>
            </div>

            <input tabindex="{{tabLevel + 54}}" type='button' (click)="submitTripPlanException(); addResonOverlay.hide();" value="Done" class="p-button-secondary block-button" />
        </p-overlayPanel>
    </div>

    <div class="clearfix bre-blocks" *ngIf="lmsException?.unschdQShopExcptnInd === 'Y'">
        <p class="color-red">Select unselected Q Shop Loco & Date. </p>
        <p class="color-red">
            <span *ngIf="lmsException.qDueDate">Sched- {{lmsException.qDueDate}}</span>
            <span *ngIf="lmsException.deadDate">Dead- {{lmsException.deadDate}}</span>
        </p>
        <p class="info-text" *ngIf="selectedLoco">
            <span class="pull-left add-reason">Add Q Shop & Date: </span>
            <a tabindex="{{tabLevel + 55}}" href="javascript:;;" class="select-reason" (click)="addQShopOverlay.toggle($event);">  {{selectedQShopDateDesc}} <span class="angle-down"></span>  </a>
        </p>
        <div class="clearfix color-red" *ngIf="lmsException.isLmsExceptionInAddQShop">Please select Q Shop</div>
        <p-overlayPanel #addQShopOverlay [dismissable]="true" appendTo="body">
            <div class="exception-add-shop">
                <h2> Location</h2>
                <lms-autocomplete styleClass="bre-input" [tabindex]='tabLevel + 56' spellcheck="false" [(ngModel)]="terminalSearchText" [ngClass]="'terminal-autocomplete'" [minLength]="2" [maxlength]="6" [suggestions]="filteredResults" (completeMethod)="autoCompleteForTerminal($event)"
                    (onSelect)="selectValueFromAutoComplete(terminalSearchText)" placeholder="Search Terminal" (ngModelChange)="updateTerminalSearchText($event)">
                </lms-autocomplete>
                <i class="fa fa-times input-clear-icon" *ngIf="terminalSearchText" (click)='removeSearchText()'></i>
                <div class="selected-location" *ngIf="summary && terminalSearchText">
                    <label>{{summary.city}} , {{summary.stateCode}} ({{summary.milepost}})</label>
                    <div>
                        <p><span>Div:</span>{{summary.divisionName ? summary.divisionName : '-'}} <span> Subdiv:</span>{{summary && summary.subDivision ? summary.subDivision : '-'}}</p>
                    </div>
                </div>
            </div>
            <div class="exception-add-shop">
                <h2> Date</h2>
                <div class="data-scroll">
                    <ul>
                        <li *ngFor="let unschdQDate of lmsException.unschdQDateSelectionDate; let i = index;">
                            <p-radioButton labelStyleClass="radio-btn-lable" tabindex="{{tabLevel + 58 + i}}" name="selectedUnschdQDate" value="{{unschdQDate}}" label="{{unschdQDate}}" [(ngModel)]="selectedUnschdQDate"></p-radioButton>
                        </li>
                    </ul>
                </div>
            </div>
            <input tabindex="{{tabLevel + 80}}" type='button' (click)="submitQShopLocation(); addQShopOverlay.hide();" value="Done" class="p-button-secondary block-button" />
        </p-overlayPanel>
    </div>
    <div class="clearfix bre-blocks">
        <p class="color-red" *ngFor="let exceptionMessage of lmsException?.exceptionMessage">{{exceptionMessage}}</p>
    </div>
</div>